(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/race-selector/assets/javascripts/race-selector-item.js') >= 0) return;  svs.modules.push('/components/racing/race-selector/assets/javascripts/race-selector-item.js');

'use strict';

const {
  format,
  parseISO
} = dateFns;
const getGait = svs.racing.common.strings.getGait;
const GameTypeTag = svs.racing.gameTypeTag.GameTypeTag;
const {
  gameTypes,
  gameTypeToSubProductId,
  drawStates,
  raceStatuses
} = svs.racing.common.constants;
const ExtraMoney = _ref => {
  let {
    racePickerMode
  } = _ref;
  const isModeAll = racePickerMode === 'all';
  return React.createElement("div", {
    className: "race-selector-item-jackpot no-amount ".concat(isModeAll ? 'race-selector-item-extramoney race-selector-item-extramoney-all no-amount-small' : 'race-selector-item-extramoney')
  }, React.createElement("i", {
    className: "icon-default icon-money"
  }), React.createElement("div", {
    className: "jackpot-text f-bold"
  }, "".concat(isModeAll ? ' Extrapengar' : ' Extrap...')));
};
const RaceSelectorItem = _ref2 => {
  let {
    raceSummary,
    jackpot,
    racePickerMode
  } = _ref2;
  const hasHighFive = raceSummary.draws.filter(draw => draw.gameType === gameTypes.TOPP5)[0];
  const renderLabels = () => {
    if (jackpot !== undefined && jackpot.raceId === raceSummary.raceId) {
      for (let index = 0; index < jackpot.jackpots.length; index++) {
        if (jackpot.jackpots[index].userProduct === gameTypeToSubProductId[gameTypes.TOPP5] && hasHighFive) {
          return null;
        }
      }
      const extraMoneyGameMode = jackpot === null || jackpot === void 0 ? void 0 : jackpot.jackpots.filter(jackpotsUserProduct => jackpotsUserProduct.userProduct !== gameTypeToSubProductId[gameTypes.TOPP5]);
      if (extraMoneyGameMode.length > 0) {
        const label = extraMoneyGameMode[0].userProduct.toUpperCase();
        const gameTypeProp = Object.keys(gameTypeToSubProductId).find(key => gameTypeToSubProductId[key] === label);
        return React.createElement(GameTypeTag, {
          gameType: gameTypeProp
        });
      }
      return null;
    }
  };
  const presentExtraMoney = Boolean(jackpot !== undefined && (jackpot === null || jackpot === void 0 ? void 0 : jackpot.jackpots.filter(jackpotsUserProduct => jackpotsUserProduct.userProduct !== gameTypeToSubProductId[gameTypes.TOPP5]).length) > 0 && raceSummary.raceId === jackpot.raceId);
  const toStart = format(parseISO(raceSummary.startTime), 'HH:mm').split(':');
  const minutesToStart = parseInt(toStart[0] * 60, 10) + parseInt(toStart[1], 10);
  const pxToStart = minutesToStart * 3 + 230;
  const itemClass = {
    left: "".concat(pxToStart, "px")
  };
  return React.createElement("div", {
    className: "race-selector-item ".concat(racePickerMode, "-item").concat(raceSummary.raceDrawState > drawStates.OPENED ? ' closed' : ''),
    style: itemClass
  }, hasHighFive && React.createElement(GameTypeTag, {
    gameType: gameTypes.TOPP5
  }), !hasHighFive && renderLabels(), React.createElement("div", {
    className: "race-selector-item-gait ".concat(raceSummary.raceDrawState === drawStates.OPENED ? 'playable' : '')
  }, getGait(raceSummary.gait)), React.createElement("div", {
    className: "race-selector-item-race-number ".concat(raceSummary.raceDrawState === drawStates.OPENED ? 'playable' : '', " ").concat(jackpot ? 'race-selector-item-race-number-with-jackpot' : '')
  }, "Lopp", ' ', raceSummary.raceNumber), React.createElement("div", {
    className: "race-selector-item-status"
  }, raceSummary.raceStatus === raceStatuses.STARTED && React.createElement("span", {
    className: "race-selector-item-status-ongoing"
  }, React.createElement("i", {
    className: "icon-default fc-sport-live icon-livestream"
  }), "\xA0P\xE5g\xE5r"), raceSummary.raceStatus !== raceStatuses.STARTED && format(parseISO(raceSummary.startTime), 'HH:mm')), jackpot !== undefined && (jackpot === null || jackpot === void 0 ? void 0 : jackpot.jackpots.filter(jackpotsUserProduct => jackpotsUserProduct.userProduct === gameTypeToSubProductId[gameTypes.TOPP5]).length) > 0 && hasHighFive && React.createElement("div", {
    className: "race-selector-item-jackpot no-amount ".concat(racePickerMode === 'all' ? 'no-amount-small' : '')
  }, React.createElement("i", {
    className: "icon-default icon-jackpot"
  }), React.createElement("div", {
    className: "jackpot-text f-bold"
  }, "Jackpot")), presentExtraMoney && !hasHighFive && React.createElement(ExtraMoney, {
    racePickerMode: racePickerMode
  }));
};
svs.racing.RaceSelectorItem = RaceSelectorItem;

 })(window);